Ext.define('SA.BrowserTab', {
    constructor(replacedCallback) {
        this.replacedCallback = replacedCallback;
        this.storageListener = SA.Storage.addListener(() => this.onStorageEvent());

        SA.BrowserTabId.ensureSet();
        SA.ActiveTabId.set(SA.BrowserTabId.get());
    },

    cancelReplacedListener() {
        this.storageListener.remove();
    },

    onStorageEvent() {
        if (SA.BrowserTabId.get() !== SA.ActiveTabId.get()) {
            this.replacedCallback();
        }
    }
});